import React, { useEffect, useState } from 'react';
import { Space, Button, Tooltip } from 'antd';
import DeletePopup from 'Molecules/DeletePopup';
import { Popup } from 'Atoms/Popup';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { useTranslate } from 'Translate';

export default (props) => {
  const { btnAction1, recordId, onRemove, title, removeTitle, extraBtn, extraBtnTooltip, extraBtnIcon, extraBtnAction, allowedEdit, allowedDelete } = props;
  const [removeVisible, setRemoveVisible] = useState(false);
  const i18n = useTranslate();
  const { t } = i18n;

  const popup = {
    closable: false,
    visibility: removeVisible,
    class: 'black-modal',
    content: <DeletePopup title={title} x loading={props.loading} onClose={() => setRemoveVisible(false)} onDelete={() => { 
      onRemove(recordId);
      setTimeout(() => setRemoveVisible(false), 500);
    }} />,
    width: 536,
    onCancel: () => setRemoveVisible(false),
  };

  return (
    <>
      <Space size={10}>
        {extraBtn &&
          <Tooltip title={extraBtnTooltip}>
            <Button
              type={'link'}
              className={'c-success'}
              onClick={extraBtnAction}
              icon={extraBtnIcon}
            />
          </Tooltip>
        }
        { // allowedEdit
          btnAction1 &&
          <Tooltip title={t("General.edit")}>
            <Button
              type={'link'}
              className={'c-primary'}
              onClick={btnAction1}
              icon={<EditOutlined />}
            />
          </Tooltip>
        }
        {
          // allowedDelete &&
          onRemove &&
          <Tooltip title={removeTitle ? removeTitle : t("General.delete")}>
            <Button
              type={'link'}
              className={'c-danger'}
              onClick={() => setRemoveVisible(true)}
              icon={<DeleteOutlined />}
            />
          </Tooltip>
        }
      </Space>
      <Popup {...popup}/>
    </>
  );
}